/* Built In Imports */

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/HNI/Components/Headings/SectionTitle';
import MediaEmbed from '@components/HNI/Components/Media/MediaEmbed';
/* Services */

/**
 * Renders the ContactUs component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} ContactUs component
 */

const Significance = ({ sectionContent, region, lang, pageBody }) => {
  const quote = pageBody.find(el => el.sectionId === 'quote-hni');
  const bg = quote?.styleConfig?.bgColour?.hex;
  const title = sectionContent.find(el => el._modelApiKey === 'section_title');
  const media = sectionContent.find(el => el._modelApiKey === 'media_embed');
  return (
    <Box
      background="#FFEBC7"
      height="100%"
      pt={{ base: '40px', lg: '10px' }}
      pb={{ base: '30px', lg: '10px' }}
      pos="relative"
      _before={{
        content: "''",
        pos: 'absolute',
        bottom: '-5px',
        height: { base: '40%', md: '42%' },
        left: '0',
        right: '0',
        background: bg,
        zIndex: '0',
      }}
      px="20px"
    >
      <Box display={{ base: 'block', sm: 'block' }}>
        <SectionTitle
          titleObj={title}
          maxW={{ sm: 360 }}
          fontSize={{ base: '26px', md: '30px' }}
          mt="0"
          mb={{ base: '1rem' }}
        />
      </Box>
      <Box pos="relative" zIndex={1} maxW="760px" mx={'auto'} width={'100%'}>
        <MediaEmbed sectionContent={media} />
      </Box>
    </Box>
  );
};

export default Significance;
